// import axios from "axios";

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if (location.hash) {
    // do the test straight away
    window.scrollTo(0, 0); // execute it straight away
    setTimeout(function () {
        window.scrollTo(0, 0); // run it a bit later also for browser compatibility
    }, 1);
}

// Lazysizes

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import { PiniaVuePlugin } from 'pinia';
import PortalVue from 'portal-vue';
import smoothScroll from '@/mixins/smoothScroll';
import { VueMasonryPlugin } from 'vue-masonry';

import header from './components/header';
import logo from './components/logo';
import video from './components/video';
import hero from './components/hero';
import contactform from './components/contactform';
import issuuModal from './components/issuu-modal';
import socialshare from './components/socialshare';
import blogdetail from './components/blog/detail';
import blogitems from './components/blog/overview';
import bloghighlight from './components/blog/highlight';
import supportitems from './components/support/overview';
import supporthighlight from './components/support/highlight';
import productoverview from './components/products/overview';
import recipesoverview from './components/recipes/overview';
import weekmenuoverview from './components/weekmenu/overview';
import recipeshighlight from './components/recipes/highlight';
import recipeweek from './components/recipes/week';
import recipedetail from './components/recipes/detail';
import recipesearch from './components/recipes/search';
import productsearch from './components/products/search';
import subpages from './components/subpages';
import inspiration from './components/inspiration';
import pagination from './components/pagination';
import bionicAdhese from './components/bionic-adhese';
import campaignSubscribe from './components/campaign-subscribe';
import newsletterSubscribe from './components/newsletter-subscribe';
import VueGoogleAutoComplete from 'vue-google-autocomplete';
import { pinia } from '@/stores';
import VueEasyLightbox from 'vue-easy-lightbox';

import { VueReCaptcha } from 'vue-recaptcha-v3';

// For more options see below
Vue.use(VueReCaptcha, {
    siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        autoHideBadge: true,
    },
});

Vue.use(VueEasyLightbox);

import 'animate.css';

/**
 * Vee Validate
 */

import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import nl from 'vee-validate/dist/locale/nl.json';

for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule],
    });
}

setInteractionMode('eager');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
Vue.use(PortalVue);
Vue.use(VueMasonryPlugin)

Vue.component('headernav', header);
Vue.component('videoplyr', video);
Vue.component('hero', hero);
Vue.component('logo', logo);
Vue.component('contactform', contactform);
Vue.component('socialshare', socialshare);
Vue.component('blogitems', blogitems);
Vue.component('blogdetail', blogdetail);
Vue.component('bloghighlight', bloghighlight);
Vue.component('supportitems', supportitems);
Vue.component('supporthighlight', supporthighlight);
Vue.component('subpages', subpages);
Vue.component('inspiration', inspiration);
Vue.component('pagination', pagination);
Vue.component('issuuModal', issuuModal);
Vue.component('productoverview', productoverview);
Vue.component('recipesoverview', recipesoverview);
Vue.component('weekmenuoverview', weekmenuoverview);
Vue.component('recipeshighlight', recipeshighlight);
Vue.component('recipeweek', recipeweek);
Vue.component('recipedetail', recipedetail);
Vue.component('recipesearch', recipesearch);
Vue.component('bionic-adhese', bionicAdhese);
Vue.component('productsearch', productsearch);
Vue.component('vue-google-autocomplete', VueGoogleAutoComplete);
Vue.component('campaign-subscribe', campaignSubscribe);
Vue.component('newsletter-subscribe', newsletterSubscribe);

Vue.prototype.svg = require('./svg');

new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    mixins: [smoothScroll],
    created() {},
    mounted() {},
    pinia,
});
